import { clearSessionAndRedirectToLogin } from "@/lib/sessionExpiry";

export type ApiError = {
  code?: string;
  message?: string;
};

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "/api").replace(
  /\/$/,
  "",
);

async function jsonFetch<T>(path: string, init: RequestInit): Promise<T> {
  const url = `${BASE_URL}${path}`;
  const res = await fetch(url, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init.headers || {}),
    },
  });

  if (res.status === 401) {
    clearSessionAndRedirectToLogin();
    throw new Error("Session expired");
  }

  const text = await res.text();
  const data = text ? (JSON.parse(text) as unknown) : null;

  if (!res.ok) {
    const err = (
      data && typeof data === "object" ? (data as ApiError) : {}
    ) as ApiError;
    const message = err.message || `HTTP ${res.status}`;
    const code = err.code;
    const e = new Error(message) as Error & { code?: string; status?: number };
    e.code = code;
    e.status = res.status;
    throw e;
  }

  return data as T;
}

export async function apiRequestPasswordReset(
  email: string,
): Promise<{ ok: true }> {
  return await jsonFetch<{ ok: true }>("/v1/auth/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export async function apiAcceptInvite(params: {
  token: string;
  password: string;
}): Promise<{ ok: true }> {
  return await jsonFetch<{ ok: true }>("/v1/auth/invite/accept", {
    method: "POST",
    body: JSON.stringify(params),
  });
}
